<template>
  <v-layout row>
    <v-flex>
      <h3 class="display-2">{{title}}</h3>
      <span class="subheading">{{subtitle}}</span>
      <v-divider v-if="divider" class="mt-3"></v-divider>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "Header",
  props: {
    title: String,
    subtitle: String,
    divider: {
      default: true,
      type: Boolean
    }
  }
};
</script>